'use client';

import { lazy, Suspense } from 'react';

export type RichTextEditorProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  showPreview?: boolean;
  proseClassName?: string;
};

const RichTextEditorImpl = lazy(() =>
  import('./RichTextEditorImpl').then((m) => ({ default: m.RichTextEditor }))
);

export function RichTextEditor(props: RichTextEditorProps) {
  return (
    <Suspense
      fallback={
        <div className="h-[200px] animate-pulse rounded-xl border border-gray-200 bg-gray-50" />
      }
    >
      <RichTextEditorImpl {...props} />
    </Suspense>
  );
}
